<template>
    <div class="slider-list">
        <div class="slider-list-item slider-list-item-add" @click="onNewClick">
            <div class="slider-list-item-container">
                <i class="el-icon-plus"></i>
                <div>Add a new slider</div>
            </div>
        </div>
        <div class="slider-list-item" v-for="item in files" :key="item.id">
            <div class="slider-list-item-container" @click="onDetailClick(item)">
                <el-image
                    class="identification-image-container"
                    :src="item.src"
                    fit="cover"
                    v-loading="upload_processing"
                >
                    <div slot="error" class="image-slot">
                        <i class="el-icon-document"></i>
                    </div>
                </el-image>
                <div class="info">
                    <div class="title">{{item.title}}</div>
                    <div class="description" v-html="item.description"></div>
                </div>
            </div>
        </div>
        <NewItem :show="showNew" :onClose="onNewClose" :data="selectedData" />
        <!-- <DetailItem :show="showDetail" :onClose="onDetailClose" :data="selectedData" /> -->
    </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapState } from "vuex";
import NewItem from "./AdminSliderNew";

export default {
    name: "AdimSliderList",
    components: {
        NewItem
    },
    data() {
        return {
            tableData: [],
            processing: false,
            upload_processing: false,
            files: [],
            showNew: false,
            selectedData: null
        };
    },
    mounted() {
        this.files = [];
        this.tableData = [];
        this.loadData();
    },
    computed: {
        ...mapState({
            arrayBufferToBase64: state => state.arrayBufferToBase64
        }),
        showDetail() {
            if (this.selectedData) {
                return true;
            }
            return false;
        }
    },
    methods: {
        ...mapActions(["request", "getError"]),
        loadData({ id = null } = {}) {
            let ctrl = this;
            ctrl.processing = true;
            ctrl.request({
                method: "GET",
                endpoint: `site_content/slider`
            })
                .then(({ data = {} }) => {
                    ctrl.tableData = data.results;
                    if (id) {
                        for (let d of this.tableData) {
                            if (d.id == id) {
                                this.selectedData = d;
                            }
                        }
                    }
                    for (let d of this.tableData) {
                        ctrl.loadFile(d);
                    }
                })
                .catch(err => {
                    ctrl.getError({
                        err
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
        loadFile(d) {
            let ctrl = this;
            ctrl.request({
                method: "GET",
                endpoint: `site_content/slider/${d.id}/${d.file_name}`,
                // responseType: "arraybuffer"
                params: { base64:1 },
            })
                .then(({ data }) => {
                    // d.src = ctrl.arrayBufferToBase64(data);
                    d.src = `data:image/jpg;base64, ${data}`;
                    ctrl.files.push(d);
                    ctrl.$forceUpdate();
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "FILE_DOWNLOAD_ERROR",
                        message: "Download file error"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    ctrl.upload_processing = false;
                });
        },
        onNewClick() {
            this.showNew = true;
        },
        onNewClose() {
            this.showNew = false;
            this.selectedData = null;
            this.files = [];
            this.tableData = [];
            setTimeout(() => {
                this.loadData();
            }, 500);
        },
        onDetailClick(row) {
            this.showNew = true;
            this.selectedData = row;
        },
        onDetailClose(reload = false, id = null) {
            this.selectedData = null;
            if (reload == true) {
                this.files = [];
                this.tableData = [];
                this.loadData({ id });
            }
        }
    }
};
</script>
<style scoped>
.slider-list {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
}

.slider-list-item {
    cursor: pointer;
    width: 380px;
    padding: 8px;
}

.slider-list-item-container {
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: #eee;
    height: 100%;
}

.slider-list-item-container:active {
    transform: scale(0.95);
}

.slider-list-item .el-image {
    height: 240px;
    overflow: hidden;
}

.title {
    padding: 16px;
    font-size: 24px;
}

.description {
    padding: 16px;
    padding-bottom: 32px;

}

.slider-list-item-add .slider-list-item-container {
    align-items: center;
    align-content: center;
    justify-content: center;
    font-size: 18px;
}
</style>

<style >
</style>